import { render, staticRenderFns } from "./PerPageSelect.vue?vue&type=template&id=46b1366d"
import script from "./PerPageSelect.vue?vue&type=script&lang=js"
export * from "./PerPageSelect.vue?vue&type=script&lang=js"
import style0 from "./PerPageSelect.vue?vue&type=style&index=0&id=46b1366d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports